export type ReportFileEntry = {
  name: string;
  type: string;
  mtime: string;
  size: number;
};

const getReportPeriodEnd = (fileName: string): number | null => {
  const dateMatches = fileName.match(/\d{1,2}\.\d{1,2}\.\d{4}/g);
  if (!dateMatches) {
    return null;
  }

  for (let index = dateMatches.length; index > 0; index -= 1) {
    const [day, month, year] = dateMatches[index - 1].split('.').map(Number);
    const date = new Date(Date.UTC(year, month - 1, day));
    if (date.getUTCFullYear() === year && date.getUTCMonth() === month - 1 && date.getUTCDate() === day) {
      return date.getTime();
    }
  }

  return null;
};

export const sortReportFiles = <T extends { name: string; mtime: string }>(files: T[]): T[] =>
  files.slice().sort((left, right) => {
    const leftPeriodEnd = getReportPeriodEnd(left.name);
    const rightPeriodEnd = getReportPeriodEnd(right.name);

    if (leftPeriodEnd !== null && rightPeriodEnd === null) {
      return -1;
    }
    if (leftPeriodEnd === null && rightPeriodEnd !== null) {
      return 1;
    }
    if (leftPeriodEnd !== null && rightPeriodEnd !== null && leftPeriodEnd !== rightPeriodEnd) {
      return rightPeriodEnd - leftPeriodEnd;
    }

    const modifiedAtDifference = Date.parse(right.mtime) - Date.parse(left.mtime);
    if (Number.isFinite(modifiedAtDifference) && modifiedAtDifference !== 0) {
      return modifiedAtDifference;
    }

    return left.name.localeCompare(right.name);
  });

export const getReportDisplayName = (fileName: string) => fileName.replace(/\.pdf$/i, '').replace(/_/g, ' ');
